import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import Button from '@stories/Components/Button/Button';
import styled from 'styled-components';
const Container = styled.section ``;
const Form = styled.form `
  background: ${brand.white};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0 ${fluid(8, 12, Device.Tablet)};

  @media ${from(Device.Tablet)} {
    display: inline-flex;
  }
`;
const Prefix = styled.span `
  ${fonts.brandonGrotesque.bold};
  font-size: ${fluid(15, 18, Device.MobileLarge, Device.DesktopSmall)};
  text-transform: uppercase;
  letter-spacing: -0.03em;
`;
const Input = styled.input `
  ${fonts.brandonGrotesque.regular};

  /* Ensure iOS doesn't apply default border radius */
  -webkit-appearance: none !important;
  flex: 1;
  border: 0;
  font-size: ${fluid(16, 18, Device.MobileLarge, Device.DesktopSmall)};
  padding: 6px 12px;
`;
const Submit = styled(Button) ``;
const PostcodeSearchStyles = {
    Container,
    Form,
    Prefix,
    Input,
    Submit,
};
export default PostcodeSearchStyles;
